import React, { FC } from 'react';

import * as styles from './Link.css';

interface ILinkProps {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  children: React.ReactNode;
  href: string;
}

export const Link: FC<ILinkProps> = props => {
  return (
    <a href={props.href} onClick={props.onClick} className={styles.link}>
      {props.children}
    </a>
  );
};
